export default __webpack_public_path__ + "static/media/쉐어플러그_02.1420d3bd.png";